package com.cybersoftsolution.cybersoftsolutionweb.components.cards

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.Text



@Composable
fun WorkFlowCard(
    id: String,
    modifier: Modifier = Modifier,
    workFlowName:String,
    workFlowDescription:String?,
    workFlowItems:List<String>,
    workFlowItemsImage:String,
    onButtonClick: () -> Unit = {},
    buttonText: String = "",
    myPosition: MyPosition = MyPosition.top,
    selected:Boolean = false,
    onCardClick: () -> Unit = {},
    additionalContent: @Composable () -> Unit = {},
){

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .thenIf(
                condition = !selected,
                other = Modifier
                    .boxShadow(
                        blurRadius = (5).px,
                        spreadRadius = (5).px,
                        color = Colors.Black.copyf(alpha = 0.1f)
                    )

            )
            .thenIf(
                condition = selected,
                other = Modifier
                    .boxShadow(
                        blurRadius = (5).px,
                        spreadRadius = (5).px,
                        color = Theme.Primary.rgb
                    )

            )
//            .margin(leftRight = if (fixWidthInPx != null) 8.px else 0.px)
            .padding(8.px)
            .backgroundColor(Colors.White)
            .transition(
                Transition.of(
                    property = "box-shadow",
                    duration = 300.ms,
                    timingFunction = null,
                    delay = null
                )
            )
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Colors.White
            )
            .borderRadius(15.px)
            .onClick { onCardClick() }
            .then(modifier)
            .id(id)
    ) {



        Column (
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 8.px)
        ) {

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .fillMaxWidth()

            ) {
                Image(
//                        width = 60,
                    modifier = Modifier
                        .fillMaxWidth(30.percent)
//                    .maxWidth(30.px)
                        .backgroundColor(Theme.Withe.rgb)
                        .aspectRatio(1F)
                        .borderRadius(350.px)
                        .border {
                            color(Theme.HalfBlack.rgb)
                            width(2.px)
                            style(LineStyle.Solid)
                        }
                        .objectFit(ObjectFit.Cover),
                    src = workFlowItemsImage,
                )
                H6(
                    attrs = Modifier
//                        .fillMaxWidth()
                        .margin(topBottom = 8.px)
                        .textAlign(TextAlign.Start)
                        .toAttrs()
                ) {
                    Text(workFlowName)
                }

            }




            workFlowItems.forEach { item ->

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {

//                Ol { //Margen de vineta
                    H6(
                        attrs = Modifier
                            .color(Theme.HalfBlack.rgb)
                            .fillMaxWidth()
                            .toAttrs()
                    ) {
                        Text("\u2022 $item") //•
                    }
//                }
                }
            }
        }





    }


}

